import { ComponentProps } from 'react';
import clsx from 'clsx';

import { OpRadio } from 'new-components/DLS/OpRadio/OpRadio';

import { OpForm } from '../../OpForm';
import { useOpFormContext } from '../../OpFormContext';
import { OpSkeleton } from '../../../OpSkeleton/OpSkeleton';

import './OpFormRadioGroup.scss';

type OpFormRadioGroupProps = Pick<
  ComponentProps<typeof OpForm.Item>,
  'name' | 'rules' | 'label' | 'tooltip' | 'help' | 'initialValue'
> &
  Omit<ComponentProps<typeof OpRadio.Group>, 'name'> & {
    formItemClassName?: string;
    isLoading?: boolean;
    direction?: 'horizontal' | 'vertical';
  };

export const OpFormRadioGroup = ({
  // Form Item props
  formItemClassName,
  className,
  name,
  rules,
  label,
  tooltip,
  help,
  initialValue,
  direction = 'horizontal',

  // For skeleton loading state
  isLoading,

  ...props
}: OpFormRadioGroupProps) => {
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={formItemClassName}
      name={name}
      label={label}
      tooltip={tooltip}
      help={help}
      initialValue={initialValue}
      rules={rules}
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Button active block={props.block} />
      ) : (
        <OpRadio.Group
          className={clsx(
            'op-form-radio-group',
            { 'op-form-radio-group--vertical': direction === 'vertical' },
            className,
          )}
          disabled={isReadOnly}
          {...props}
        />
      )}
    </OpForm.Item>
  );
};
